import maintenanceProcessesUtils from '@/pages/Processes/Maintenance/MaintenanceProcesses/maintenanceProcesses.utils.ts'
import MaintenanceBlankDropdown from '@/pages/Processes/Maintenance/MaintenanceBlanks/components/MaintenanceBlankDropdown'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import EquipmentModelsMultiSelect from '@/pages/Equipment/pages/EquipmentModels/components/EquipmentModelsMultiSelect'
import SeparateLine from '@/shared/Forms/SeparateLine'
import { TCreateMaintenanceProcessDTO } from '@/pages/Processes/Maintenance/maintenance.types.ts'

interface IProps {
  process: TCreateMaintenanceProcessDTO
  handleChange: (val: any, key: string) => void
  handleRuleUpdate: (index: number, val: any, key: string) => void
}

const MaintenanceProcessFormFields = (props: IProps) => {
  const renderProcessRules = () => {
    return props.process.rules.map((r, index) => (
      <div className="flex-lines gap4" key={index}>
        <p className="text-nm">{maintenanceProcessesUtils.getPeriodName(r.period)}</p>
        <MaintenanceBlankDropdown
          selectedBlankId={r.blankSchemaId}
          name="blankSchemaId"
          onChange={(val, name) => props.handleRuleUpdate(index, val, name)}
        />
      </div>
    ))
  }

  return (
    <>
      <FormField label="Наименование процесса ТО" required={true}>
        <TextInput
          value={props.process.name}
          name="name"
          onChange={props.handleChange}
          placeHolder="Введите наименование"
        />
      </FormField>
      <FormField label="Модели лифтов" required={true}>
        <EquipmentModelsMultiSelect
          selected={props.process.equipmentModels}
          onSelect={props.handleChange}
          name="equipmentModels"
        />
      </FormField>
      <SeparateLine />
      <h5 className="text-heading-5">Правила обслуживания</h5>
      {renderProcessRules()}
    </>
  )
}

export default MaintenanceProcessFormFields
